document.addEventListener("DOMContentLoaded", () => {
    const allVideos = [];
    let lastScrollPosition = window.pageYOffset;
    const scrollThreshold = 50;
    let isScrolling = false;
    let cachedViewportData = new Map();

    let viewportWidth = window.innerWidth;
    let viewportHeight = window.innerHeight;

    function initializeVideoControls(sectionId) {
        const section = document.getElementById(`ugc-video-section-${sectionId}`);
        if (!section) return;

        const videos = Array.from(section.querySelectorAll(".ugc-video-element"));
        allVideos.push(...videos);

        videos.forEach((video, index) => {
            const videoContainer = video.closest(".ugc-video-container");

            const controls = {
                muteButton: videoContainer.querySelector(".mute-mobile-icon"),
                unmuteButton: videoContainer.querySelector(".unmute-mobile-icon"),
                playButton: videoContainer.querySelector(".play-button"),
                pauseButton: videoContainer.querySelector(".pause-button")
            };

            video.muted = true;

            const videoData = {
                video,
                videoContainer,
                controls,
                isInViewport: false,
                lastKnownRect: null
            };

            cachedViewportData.set(video, videoData);
            updateButtonVisibility(videoData);

            function togglePlayPause() {
                if (video.paused) {
                    video
                        .play()
                        .then(() => {
                            muteOtherVideos(video);
                            updateButtonVisibility(videoData);
                        })
                        .catch((error) => console.error("Play error:", error));
                } else {
                    video.pause();
                    updateButtonVisibility(videoData);
                }
            }

            function toggleMuteUnmute() {
                video.muted = !video.muted;
                if (!video.muted) {
                    muteOtherVideos(video);
                }
                updateButtonVisibility(videoData);
            }

            function updateButtonVisibility(data) {
                const { videoContainer, controls, video } = data;
                const isHovered = videoContainer.matches(":hover");

                requestAnimationFrame(() => {
                    if (isHovered) {
                        if (controls.playButton) {
                            controls.playButton.style.display = video.paused ? "flex" : "none";
                        }
                        if (controls.pauseButton) {
                            controls.pauseButton.style.display = video.paused ? "none" : "flex";
                        }

                        if (controls.muteButton) {
                            controls.muteButton.style.display = video.muted ? "flex" : "none";
                        }
                        if (controls.unmuteButton) {
                            controls.unmuteButton.style.display = video.muted ? "none" : "flex";
                        }
                    } else {
                        Object.values(controls).forEach(button => {
                            if (button) button.style.display = "none";
                        });
                    }
                });
            }

            function muteOtherVideos(currentVideo) {
                cachedViewportData.forEach((data, otherVideo) => {
                    if (otherVideo === currentVideo) return;

                    otherVideo.muted = true;
                    const { videoContainer, controls } = data;

                    requestAnimationFrame(() => {
                        const isHovered = videoContainer.matches(":hover");
                        if (isHovered && controls.muteButton) {
                            controls.muteButton.style.display = "flex";
                        } else if (controls.muteButton) {
                            controls.muteButton.style.display = "none";
                        }
                        if (controls.unmuteButton) {
                            controls.unmuteButton.style.display = "none";
                        }
                    });
                });
            }

            videoContainer.addEventListener("mouseenter", () => updateButtonVisibility(videoData), { passive: true });
            videoContainer.addEventListener("mouseleave", () => updateButtonVisibility(videoData), { passive: true });
            video.addEventListener("click", togglePlayPause);

            if (controls.muteButton) {
                controls.muteButton.addEventListener("click", (e) => {
                    e.stopPropagation();
                    toggleMuteUnmute();
                });
            }

            if (controls.unmuteButton) {
                controls.unmuteButton.addEventListener("click", (e) => {
                    e.stopPropagation();
                    toggleMuteUnmute();
                });
            }

            if (controls.playButton) {
                controls.playButton.addEventListener("click", (e) => {
                    e.stopPropagation();
                    togglePlayPause();
                });
            }

            if (controls.pauseButton) {
                controls.pauseButton.addEventListener("click", (e) => {
                    e.stopPropagation();
                    togglePlayPause();
                });
            }

            video.addEventListener("play", () => updateButtonVisibility(videoData), { passive: true });
            video.addEventListener("pause", () => updateButtonVisibility(videoData), { passive: true });
            video.addEventListener("volumechange", () => updateButtonVisibility(videoData), { passive: true });

            updateButtonVisibility(videoData);
        });
    }

    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            const videoData = cachedViewportData.get(video);
            if (!videoData) return;

            videoData.isInViewport = entry.isIntersecting;

            if (!entry.isIntersecting) {
                video.muted = true;
                const { controls, videoContainer } = videoData;

                requestAnimationFrame(() => {
                    const isHovered = videoContainer.matches(":hover");
                    if (controls.muteButton) {
                        controls.muteButton.style.display = isHovered ? "flex" : "none";
                    }
                    if (controls.unmuteButton) {
                        controls.unmuteButton.style.display = "none";
                    }
                });
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '50px'
    });

    function isElementInViewportFallback(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= -rect.height &&
            rect.left >= -rect.width &&
            rect.top <= viewportHeight &&
            rect.left <= viewportWidth
        );
    }

    function handleScroll() {
        if (isScrolling) return;
        isScrolling = true;

        const currentScrollPosition = window.pageYOffset;
        const scrollDifference = Math.abs(currentScrollPosition - lastScrollPosition);

        if (scrollDifference > scrollThreshold) {
            if ('IntersectionObserver' in window) {
                lastScrollPosition = currentScrollPosition;
            } else {
                cachedViewportData.forEach((data, video) => {
                    if (!isElementInViewportFallback(video)) {
                        video.muted = true;
                        const { controls, videoContainer } = data;

                        requestAnimationFrame(() => {
                            const isHovered = videoContainer.matches(":hover");
                            if (controls.muteButton) {
                                controls.muteButton.style.display = isHovered ? "flex" : "none";
                            }
                            if (controls.unmuteButton) {
                                controls.unmuteButton.style.display = "none";
                            }
                        });
                    }
                });
                lastScrollPosition = currentScrollPosition;
            }
        }

        isScrolling = false;
    }

    let scrollTimeout;
    window.addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScroll, 100);
    }, { passive: true });

    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            viewportWidth = window.innerWidth;
            viewportHeight = window.innerHeight;
        }, 250);
    }, { passive: true });

    document.querySelectorAll(".ugc-video").forEach((section) => {
        const sectionId = section.id.replace("ugc-video-section-", "");
        initializeVideoControls(sectionId);
    });

    if ('IntersectionObserver' in window) {
        allVideos.forEach(video => {
            intersectionObserver.observe(video);
        });
    }

    window.addEventListener("beforeunload", () => {
        if (intersectionObserver) {
            intersectionObserver.disconnect();
        }
        cachedViewportData.clear();
    });
});